import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["stroke-width", "cx", "cy", "r"]

import { toRefs } from 'vue';

interface LoaderProps {
  size?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    size: { default: 24 }
  },
  setup(__props: any) {

const props = __props;

const { size } = toRefs(props);
const viewBoxSize = `0 0 ${size.value} ${size.value}`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "spinner",
    width: _unref(size),
    height: _unref(size),
    viewBox: viewBoxSize,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("circle", {
      class: "path",
      fill: "none",
      "stroke-width": _unref(size) / 6,
      "stroke-linecap": "round",
      cx: _unref(size) / 2,
      cy: _unref(size) / 2,
      r: _unref(size) / 2 - 3
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})